import * as actionTypes from "./types";

export const setPageTitle = (title) => {
  return { type: actionTypes.PAGE_SET_TITLE, title: title };
};
